import * as React from "react";

import { nullElement } from "../../TypingUtils";

export interface VisibilityWrapperProps {
    wrapElement: undefined | "div" | "span";
    visible: boolean;
    children: React.ReactNode;
}

export function VisibilityWrapper(props: VisibilityWrapperProps): JSX.Element | null {
    if (!props.visible) {
        return nullElement;
    }
    const WrapComponent = props.wrapElement ?? React.Fragment;
    return <WrapComponent>{props.children}</WrapComponent>;
}
